import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  const [home, sethome] = useState(false)
  const [recruitment, setrecruitment] = useState(false)
  const [hrm, sethrm] = useState(false)
  const [app, setapp] = useState(false)
  const [email, setemail] = useState(false)
  const [ecommerce, setecommerce] = useState(false)
  const [crypto, setcrypto] = useState(false)
  const [project, setproject] = useState(false)
  const [task, settask] = useState(false)
  const [contact, setcontact] = useState(false)
  const [blog, setBlog] = useState(false)
  const [component, setcomponent] = useState(false)
  const [form, setform] = useState(false)
  const [table, settable] = useState(false)
  const [chart, setchart] = useState(false)
  const [icon, seticon] = useState(false)
  const [map, setmap] = useState(false)
  const [extra, setextra] = useState(false)
  const [invoice, setinvoice] = useState(false)
  const [auth, setauth] = useState(false)
  const [utility, setutility] = useState(false)
  const [level, setLevel] = useState("")

  useEffect(() => {
    if (localStorage.getItem("authMildUser")) {
      const obj = JSON.parse(localStorage.getItem("authMildUser"))
      setLevel(obj.level)
    }
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })
  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {props.userRole != "Applicant" && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-light"
                      onClick={e => {
                        sethome(!home)
                      }}
                      to="/dashboard"
                    >
                      <i className="bx bx-home-circle me-2"></i>
                      Home {props.menuOpen}
                    </Link>
                  </li>
                )}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none text-light"
                    onClick={e => {
                      sethome(!home)
                    }}
                    to="/approvals"
                  >
                    <i className="bx bx-align-justify me-2"></i>
                    Approvals {props.menuOpen}
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none text-light"
                    onClick={e => {
                      e.preventDefault()
                      sethrm(!hrm)
                    }}
                    to="#"
                  >
                    <i className="mdi mdi-human-queue me-2"></i>
                    Human Resource Management {props.menuOpen}
                    <div className="arrow-down"></div>
                  </Link>

                  <div className={classname("dropdown-menu", { show: hrm })}>
                    {
                      /*<div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          sethrm(!hrm);
                        }}
                      >
                        Recruitment Management <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/recruitment" className="dropdown-item">
                          Recruitments
                        </Link>
                        <Link to="/recruitment-requisitions" className="dropdown-item">
                          Recruitment Requisitions
                        </Link>
                        <Link to="/recruitment-applicants" className="dropdown-item">
                          Applicants
                        </Link>
                        <Link to="/applicants-login" className="dropdown-item">
                          Applicants Login - Public
                        </Link>
               
                      </div>
                    </div>*/
                      <div className="dropdown">
                        <Link
                          to="/leave"
                          className="dropdown-item dropdown-toggle arrow-none"
                          onClick={e => {
                            e.preventDefault()
                            sethrm(!hrm)
                          }}
                        >
                          Leave Management <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", { show: hrm })}
                        >
                          <Link to="/leave" className="dropdown-item">
                            Leave
                          </Link>
                          <Link to="/leave-requests" className="dropdown-item">
                            My Open Leave Requests
                          </Link>
                          <Link
                            to="/submitted-leave-requests"
                            className="dropdown-item"
                          >
                            My Submitted Leave Requests
                          </Link>
                          <Link
                            to="/posted-leave-requests"
                            className="dropdown-item"
                          >
                            My Approved Leave Requests
                          </Link>
                          <Link to="/leave-approvals" className="dropdown-item">
                            Leave Requests to Approve
                          </Link>
                        </div>
                      </div>
                    }
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          sethrm(!hrm)
                        }}
                      >
                        Performance Appraisals{" "}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/appraisals" className="dropdown-item">
                          Appraisals
                        </Link>
                        <Link
                          to="/individual-performance-agreement"
                          className="dropdown-item"
                        >
                          Individual Performance Agreements
                        </Link>
                        <Link
                          to="/performance-appraisals"
                          className="dropdown-item"
                        >
                          Mid Term Appraisals
                        </Link>
                        <Link
                          to="/full-performance-appraisals"
                          className="dropdown-item"
                        >
                          Full Term Appraisals
                        </Link>
                        <Link
                          to="/performance-improvement-plans"
                          className="dropdown-item"
                        >
                          Performance Improvement Plans
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link to="/profile" className="dropdown-item">
                        Employee BioData
                      </Link>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          sethrm(!hrm)
                        }}
                      >
                        Timesheets <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/timesheets" className="dropdown-item">
                          Timesheets
                        </Link>
                        <Link to="/my-timesheets" className="dropdown-item">
                          My Open Timesheets
                        </Link>
                        <Link
                          to="/my-submitted-timesheets"
                          className="dropdown-item"
                        >
                          My Submitted Timesheets
                        </Link>
                        <Link
                          to="/my-rejected-timesheets"
                          className="dropdown-item"
                        >
                          My Rejected Timesheets
                        </Link>
                        <Link
                          to="/approved-timesheets"
                          className="dropdown-item"
                        >
                          My Approved Timesheets
                        </Link>
                        <Link
                          to="/timesheet-approvals"
                          className="dropdown-item"
                        >
                          Timesheets to Approve
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          sethrm(!hrm)
                        }}
                      >
                        Grievances <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/grievances" className="dropdown-item">
                          Grievances
                        </Link>
                        <Link
                          to="/disciplinary-setup"
                          className="dropdown-item"
                        >
                          Grievances Types
                        </Link>
                        <Link to="/grievance-cases" className="dropdown-item">
                          Grievance Cases
                        </Link>
                        <Link to="/cases-to-answer" className="dropdown-item">
                          Grievance Cases To Respond to
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          sethrm(!hrm)
                        }}
                      >
                        Training <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/training/" className="dropdown-item">
                          Training
                        </Link>
                        <Link
                          to="/personal-development-plan"
                          className="dropdown-item"
                        >
                          Personal Development Plan
                        </Link>
                        <Link to="/training-plan" className="dropdown-item">
                          Training Plans
                        </Link>
                        <Link to="#" className="dropdown-item">
                          Training Requests
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          sethrm(!hrm)
                        }}
                      >
                        Exit Management <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: hrm })}
                      >
                        <Link to="/exit" className="dropdown-item">
                          Staff Exit
                        </Link>
                        <Link to="/exit-interviews" className="dropdown-item">
                          Exit Interview
                        </Link>
                        <Link to="/staff-handover" className="dropdown-item">
                          Staff Handover
                        </Link>
                        <Link to="/exit-approvals" className="dropdown-item">
                          Exit Approvals
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none text-light"
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                    }}
                  >
                    <i className="mdi mdi-cart-arrow-down me-2"></i>
                    Purchase Management <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: extra })}>
                    <Link to="/purchases" className="dropdown-item">
                      Purchases
                    </Link>
                    <Link to="/purchase-requisitions" className="dropdown-item">
                      My Open Purchase Requisitions
                    </Link>
                    <Link
                      to="/submitted-purchase-requisitions"
                      className="dropdown-item"
                    >
                      My Submitted Purchase Requisitions
                    </Link>
                    <Link
                      to="/approved-purchase-requisitions"
                      className="dropdown-item"
                    >
                      My Approved Purchase Requisitions
                    </Link>
                    <Link to="/purchase-approvals" className="dropdown-item">
                      Purchase Requisitions to Approve
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown" style={{ display: "none" }}>
                  <Link
                    className="nav-link dropdown-toggle arrow-none text-light"
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                    }}
                  >
                    <i className="mdi mdi-cash-refund me-2"></i>
                    Payment Management <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: extra })}>
                    <Link to="/payments" className="dropdown-item">
                      Payments
                    </Link>
                    <Link to="/payment-requisitions" className="dropdown-item">
                      My Open Payment Requisitions
                    </Link>
                    <Link
                      to="/submitted-payment-requisitions"
                      className="dropdown-item"
                    >
                      My Submitted Payment Requisitions
                    </Link>
                    <Link
                      to="/approved-payment-requisitions"
                      className="dropdown-item"
                    >
                      My Approved Payment Requisitions
                    </Link>
                    <Link to="/payment-approvals" className="dropdown-item">
                      Payment Requisitions to Approve
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  {/* <Link
                    className="nav-link dropdown-toggle arrow-none text-light"
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      
                    }}
                  >
                    <i className="mdi mdi-car-multiple me-2"></i>
                    Fleet Management <div className="arrow-down"></div>
                  </Link> */}
                  <div className={classname("dropdown-menu", { show: extra })}>
                    <Link to="/fleet" className="dropdown-item">
                      Fleet
                    </Link>
                    <Link to="/fleet-requisitions" className="dropdown-item">
                      Fleet Requisitions
                    </Link>
                  </div>
                </li>

                {level == "Administrator" && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-light"
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                      }}
                    >
                      <i className="mdi mdi-account-settings-outline me-2"></i>
                      SetUp <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", { show: extra })}
                    >
                      <Link to="/system-users" className="dropdown-item">
                        Users
                      </Link>
                      <Link to="/companies" className="dropdown-item">
                        Companies
                      </Link>
                    </div>
                  </li>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  userRole: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
